<div class="content">
  <div class="content-panel">
    <h2 translate>page.export.export-echantillons.title</h2>

    <div class="p-2">
      <!-- Formulaire de recherche avancée -->
      <form [formGroup]="formFilter" #form="ngForm" (ngSubmit)="onExport()"
            style="flex-direction: column; align-items: flex-start;">
        <div class="row">
          <!-- Année de contrôle -->
          <div class="col-md-2">
            <div class="mb-3">
              <label class="form-label" for="anneeControle" translate>page.export.export-echantillons.annee-controle</label> :
              <input id="anneeControle" formControlName="anneeControle" maxlength="4" class="form-control annee-input" />
            </div>
          </div>

          <!-- Millésime -->
          <div class="col-md-2">
            <div class="mb-3">
              <label class="form-label" for="millesime" translate>page.export.export-echantillons.millesime</label> :
              <input id="millesime" formControlName="millesime" maxlength="4" class="form-control annee-input" />
            </div>
          </div>

          <!-- Cahier des charges -->
          <div class="col-md-2">
            <div class="mb-3">
              <label class="form-label" for="cdc" translate>page.export.export-echantillons.cdc</label> :
              <div *ngIf="cahiers">
                <app-multiselect id="cdc" controlName="cahier" [items]="cahiers"
                                 bindLabel="libelle" maxWidth="initial" class="form-control-multiselect type-input">
                </app-multiselect>
              </div>
            </div>
          </div>

          <!-- Tournées -->
          <div class="col-md-2">
            <div class="mb-3">
              <label class="form-label" for="tournee" translate>page.export.export-echantillons.tournees</label> :
              <select id="tournee" formControlName="tournee" class="form-select">
                <option [ngValue]="null" translate>Toutes</option>
                <ng-container *ngFor="let tournee of tournees">
                  <option [ngValue]="tournee">{{ tournee.dateDebut | date:'dd/MM/yyyy' }} ({{tournee.numero}})</option>
                </ng-container>
              </select>
            </div>
          </div>

          <!-- Commissions -->
          <div class="col-md-2">
            <div class="mb-3">
              <label class="form-label" for="commission" translate>page.export.export-echantillons.commissions</label> :
              <select id="commission" formControlName="commission" class="form-select">
                <option [ngValue]="null" translate>Toutes</option>
                <ng-container *ngFor="let commission of commissions">
                  <option [ngValue]="commission">{{ commission.dateDebut | date:'dd/MM/yyyy' }} ({{commission.numero}})</option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
        <!-- Bouton d'export -->
        <div class="actions-bar">
          <button type="submit" class="btn btn-primary ms-2" translate>label.exporter</button>
        </div>
      </form>
    </div>
    <!-- Aucune résultat -->
    <div *ngIf="hasResult && echantillons.length === 0" class="alert alert-warning alert-block" translate>
      <fa-icon icon="exclamation"></fa-icon> page.export.export-echantillons.aucun-resultat
    </div>
  </div>
</div>

